<template>
  <div class="main-card">
    <img v-if="!isNative" :class="{ 'main-head': !isNative }" src="../../../assets/main-head.png" alt="" />
    <div v-if="!isNative" class="safety-warning">
      <div class="tips">
        <img :src="safetyIcon" alt="" />
        <span>账户安全保障中</span>
      </div>
    </div>
    <div v-else class="right-corner" />

    <div class="main-info" :class="setBorderStyle">
      <div class="main-title">
        <span>可用余额 (元)</span>
        <img :src="getEyesStatus" alt="" @click="changeEyesStatus" />
      </div>
      <div class="main-amount">
        <span class="money">{{ getBalanceInfos }}</span>
        <span v-if="isNative" class="not-freeze-pgy freeze-amount">
          <Pgy pos-id="12824" swimlane="pay01" :utm_source="utm_source" :env="pgyEnv" />
        </span>
      </div>

      <!-- 引导模块-pgy资源位，CSR，不同的用户状态的引导功能 -->
      <Pgy v-if="isNative" class="pgy-12833" pos-id="12833" :options="pgyLxParams" @refresh-data="guideRefreshPage" />

      <!-- 按钮模块 -->
      <div class="button-info" :class="{ ['is-guide-pgy']: isNative }">
        <div v-if="pageData.withdrawButtonFlag" class="button-item button-normal" @click="jumpWithdraw">提现</div>
        <div v-if="pageData.rechargeButtonFlag" class="button-item button-highlight" @click="jumpRecharge">充值</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { refreshPage } from '@/service/fetchIndexData';
import { riskModal } from '@/service/riskControl';
import {
  env,
  analytics,
  analyticConfig,
  bridge,
  checkUrl,
  request,
  monitor,
  safetyIcon,
  baLanceMoneySet,
  AccountStatus,
  TradeType,
  getUrl,
} from '@/common';
import { accountCheck } from '@/service/accountCheck';
import Pgy from './Pgy.vue';

export default Vue.extend({
  name: 'MainInfo',
  components: {
    Pgy,
  },
  props: {
    pageData: {
      default: () => ({} as MainPageData),
      type: Object as () => MainPageData,
    },
    showBindCardEntry: {
      default: false,
      type: Boolean,
    },
    pgyEnv: {
      default: 'prod',
      type: String,
    },
  },
  data() {
    return {
      TradeType,
      safetyIcon,
      eyesOpenStatus: true,
      isNative: env.isNative,
      utm_source: env.utmSource,
    };
  },
  computed: {
    getEyesStatus(): string {
      if (!this.eyesOpenStatus) {
        return baLanceMoneySet.close;
      }
      return baLanceMoneySet.open;
    },
    balanceAmount(): string {
      return (this.pageData as MainPageData).availableAmount || (this.pageData as MainPageData).amount || '0.00';
    },
    getBalanceInfos(): string {
      if (!this.eyesOpenStatus) {
        return '****';
      }
      return this.balanceAmount;
    },
    guideInfo(): GuideInfoType {
      return (this.pageData as MainPageData).guideInfo || {};
    },

    // 充值关闭
    rechargeClose(): boolean {
      return !!(this.pageData as MainPageData).rechargeStatus;
    },

    // 提现关闭
    withdrawClose(): boolean {
      return !!(this.pageData as MainPageData).withdrawStatus;
    },

    setBorderStyle(): {} {
      if (this.showBindCardEntry) {
        return {
          hasBindCardEntry: true,
          'main-info-native': this.isNative,
        };
      }
      return {
        noBindCardEntry: true,
        'main-info-native': this.isNative,
      };
    },

    pgyLxParams(): any {
      return {
        lxData: {
          from: env.scene,
          module_type: this.pageData?.payAccountStatus || 1,
        },
        isInside: true,
      };
    },
  },
  watch: {
    pageData: {
      handler(val: MainPageData) {
        if (val) {
          analytics.mv(
            analyticConfig.index.bid.availableAmountShow,
            {
              show_amount: val.availableAmount || val.amount || '0.00',
            },
            analyticConfig.index.cid
          );
        }
      },
    },
  },
  mounted() {
    this.reportMv();
  },
  methods: {
    changeEyesStatus() {
      this.eyesOpenStatus = !this.eyesOpenStatus;
    },
    jumpRecharge() {
      let url = '';
      if (env.isNative) {
        url = getUrl(`/recharge.html?scene=${env.scene}&from=maininfo`);
      } else {
        const currentUrl = new URL(window.location.href);
        currentUrl.pathname = currentUrl.pathname.replace(/\w+\.html/, 'recharge.html');
        currentUrl.searchParams.set('from', 'maininfo');
        url = currentUrl.toString();
      }
      analytics.click(analyticConfig.index.bid.jumpRechargeBtnClick, {
        tradeNo: '-999',
      });
      this.clickHandler(url, 'recharge');
    },

    jumpWithdraw() {
      let url = '';
      if (env.isNative) {
        url = getUrl(`/withdraw.html?scene=${env.scene}&from=maininfo`);
      } else {
        const currentUrl = new URL(window.location.href);
        currentUrl.pathname = currentUrl.pathname.replace(/\w+\.html/, 'withdraw.html');
        currentUrl.searchParams.set('from', 'maininfo');
        url = currentUrl.toString();
      }
      analytics.click(analyticConfig.index.bid.jumpWithdrawBtnClick, {});
      this.clickHandler(url, 'withdraw');
    },

    clickHandler(url: string, type: 'withdraw' | 'recharge') {
      // 因不同的账户类型需要去实名认证、身份验证等功能。此功能为会员服务，但会员侧暂不支持，因此本期暂不放开小程序的提现、充值入口
      if ((this.rechargeClose && type === 'recharge') || (this.withdrawClose && type === 'withdraw')) {
        riskModal((this.pageData as MainPageData).riskControlAlert);
        return;
      }
      // 账户状态获取异常，重新请求
      if (this.guideInfo?.[type]?.type === AccountStatus.Exception) {
        this.fetchGuideInfo(url, type);
      } else if (this.guideInfo?.[type]?.type === AccountStatus.Normal) {
        refreshPage();
        bridge.openPage(checkUrl(url), 1);
      } else {
        accountCheck({
          data: this.guideInfo,
          type,
          url,
          cid: analyticConfig.index.cid,
          refresh: refreshPage,
          isToCallBackUrl: true,
          fromPage: 'index',
        });
      }
    },

    // 账户状态异常，重试
    fetchGuideInfo(url: string, type: 'withdraw' | 'recharge') {
      request
        .fetchGuideInfo()
        .then((res) => {
          this.$emit('setGuideInfo', res.data.guideInfo);
          if (res.data.guideInfo?.[type]?.type === AccountStatus.Exception) {
            throw res.data.guideInfo?.[type];
          }
          this.clickHandler(url, type);
        })
        .catch((err) => {
          const title = err?.title || '系统遇到问题';
          const content = err?.body || '请稍后再试';
          analytics.mv(analyticConfig.guideInfo.mv, {
            popup_type: '-1',
          });
          this.$modal.show({
            title,
            content,
            preventScroll: true,
            className: 'account-info-modal',
            button: {
              text: err?.confirmButton || '知道了',
              onClick: () => {
                analytics.addTag(
                  {
                    bid: analyticConfig.guideInfo.mc,
                    from: env.scene,
                    utm_source: env.utmSource,
                    button_name: err?.confirmButton || '知道了',
                    popup_type: '-1',
                  },
                  analyticConfig.index.cid
                );
                analytics.click(analyticConfig.guideInfo.mc, {
                  button_name: err?.confirmButton || '知道了',
                  popup_type: '-1',
                });
                this.$modal.hide();
              },
            },
          });
        });
    },

    guideRefreshPage() {
      this.$emit('guideRefreshPage');
    },

    reportMv() {
      analytics.mv(
        analyticConfig.index.bid.jumpRechargeBtnShow,
        {
          tradeNo: '-999',
        },
        analyticConfig.index.cid
      );
      analytics.mv(analyticConfig.index.bid.jumpWithdrawBtnShow, {}, analyticConfig.index.cid);
    },
  },
});
</script>

<style lang="less" scoped>
.main-card {
  position: relative;
  .main-head {
    position: absolute;
    width: 2.8rem;
    height: 2.8rem;
    right: 0;
    top: -0.2rem;
    pointer-events: none;
  }
  .safety-warning {
    height: 1.33rem;
    background-image: linear-gradient(92deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 99%);
    border-radius: 0.32rem;
    padding-left: 0.36rem;
    padding-top: 0.24rem;
    .tips {
      display: flex;
      align-items: center;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      span {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.26rem;
        color: #996a2d;
        letter-spacing: 0;
        line-height: 0.26rem;
        font-weight: 400;
        margin-left: 0.04rem;
      }
    }
  }
  .right-corner {
    position: absolute;
    right: 0.01rem;
    top: 0.77rem;
    width: 2.76rem;
    height: 1rem;
    background: white;
    border-top-right-radius: 0.32rem;
  }
}
.main-info {
  background: #fff;
  margin-top: -0.56rem;
  padding: 0.36rem;
  padding-top: 0.69rem;
  .main-title {
    display: flex;
    span {
      font-weight: 400;
      color: #00000099;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.28rem;
      line-height: 0.28rem;

      letter-spacing: 0;
    }
    img {
      margin-left: 0.12rem;
      width: 0.28rem;
      height: 0.28rem;
    }
  }
  .main-amount {
    margin-top: 0.16rem;
    position: relative;
    .money {
      font-family: MTNewDigitalDisplay-Medium, monospace;
      font-size: 0.76rem;
      color: rgba(0, 0, 0, 0.9);
      letter-spacing: 0.02rem;
      text-align: center;
      line-height: 0.84rem;
      margin-right: 0.16rem;
    }
    .freeze-amount {
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.22rem;
      color: rgba(0, 0, 0, 0.6);
      letter-spacing: 0;
      line-height: 0.3rem;
      font-weight: 400;
      background: #f5f5f5;
      border-radius: 0.06rem;
      padding: 0.04rem 0.08rem;
      position: absolute;
      bottom: 0.1rem;
    }
    .not-freeze-pgy {
      background: transparent;
      bottom: 0.01rem;
      margin-left: -0.08rem;
    }
  }
  .pgy-12833 {
    margin-top: 0.32rem;
  }
  .button-info {
    margin-top: 0.53rem;
    padding-bottom: 0.12rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    .button-item {
      box-sizing: content-box;
      padding: 0.18rem 1.22rem;
      border-radius: 0.48rem;
      font-family: PingFangSC-Medium, sans-serif;
      font-size: 0.3rem;
      color: #191919;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.42rem;
      font-weight: 500;
    }
    .button-highlight {
      background-image: linear-gradient(104deg, #ffea4d 0%, #ffdd19 100%);
      padding: 0.19rem 1.22rem;
    }
    .button-normal {
      background: #ffffff;
      border: 0.01rem solid rgba(0, 0, 0, 0.2);
      padding: 0.18rem 1.22rem;
    }
  }
  .is-guide-pgy {
    margin-top: 0.36rem;
  }
}
.main-info-native {
  background: transparent;
  margin-top: -0.8rem;

  .main-title {
    padding-top: 0.64rem;
    align-items: center;
  }

  &::before {
    content: '';
    width: calc(100% - 2.75rem);
    height: 1rem;
    background: #fff;
    position: absolute;
    left: 0;
    top: 0.77rem;
    border-radius: 0.32rem 0 0 0;
    z-index: -1;
  }
  &::after {
    content: '';
    width: 100%;
    height: calc(100% - 1.76rem);
    background: #fff;
    position: absolute;
    left: 0;
    top: 1.76rem;
    border-radius: 0 0 0.32rem 0.32rem;
    z-index: -1;
  }
}
.hasBindCardEntry {
  border-radius: 0.32rem 0.32rem 0 0;
}
.noBindCardEntry {
  border-radius: 0.32rem;
}
</style>
